module.exports = __webpack_public_path__ + "static/113208847_m-27dceefb4214a96f092c3bde6f586e65.png";